/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_Case_StudyInputs */

const en_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`case study`)
};

const ar_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دراسة حالة`)
};

const bn_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কেস স্টাডি`)
};

const de_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallstudie`)
};

const es_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estudio de caso`)
};

const fr_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`étude de cas`)
};

const pt_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estudo de caso`)
};

const zh_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`案例研究`)
};

const tr_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`örnek olay incelemesi`)
};

const ru_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`практический пример`)
};

const pl_svd_case_study = /** @type {(inputs: Svd_Case_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`studium przypadku`)
};

/**
* | output |
* | --- |
* | "case study" |
*
* @param {Svd_Case_StudyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_case_study = /** @type {((inputs?: Svd_Case_StudyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Case_StudyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_case_study(inputs)
	if (locale === "bn") return bn_svd_case_study(inputs)
	if (locale === "de") return de_svd_case_study(inputs)
	if (locale === "es") return es_svd_case_study(inputs)
	if (locale === "fr") return fr_svd_case_study(inputs)
	if (locale === "pt") return pt_svd_case_study(inputs)
	if (locale === "zh") return zh_svd_case_study(inputs)
	if (locale === "tr") return tr_svd_case_study(inputs)
	if (locale === "ru") return ru_svd_case_study(inputs)
	if (locale === "pl") return pl_svd_case_study(inputs)
	return en_svd_case_study(inputs)
});